import React from 'react';
import styled from 'styled-components';
import { UserModel } from 'services/EpdClient';
import { HelpBox } from '../help-boxes';

interface Props {
  user: UserModel;
}

const HeaderUserImpersonateNotice: React.FC<Props> = ({ user }) => {
  return (
    <StyledHelpBox>
      <span>
        You are now logged in as
        <br />
        <ins style={{ wordBreak: 'break-word' }}>{user.email}</ins>.
      </span>
      <DontYouDareGoWider>Please log in again with your credentials to access the EPD Portal as a Super Admin.</DontYouDareGoWider>
    </StyledHelpBox>
  );
};

export default HeaderUserImpersonateNotice;

const StyledHelpBox = styled(HelpBox)`
  padding: 8px 16px;
  white-space: wrap;
`;

const DontYouDareGoWider = styled.div`
  max-width: 284px;
`;
